<template>
  <div class="Closures">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.Operation_Records') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Tax_Bill_Recent_Month') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportTaxbill"
          :otherData="{
            mediaName: '近3个月纳税申报表',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportTaxbill',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Rent_Records') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportRentrecords"
          :otherData="{
            mediaName: '近3个月房租缴纳凭证',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportRentrecords',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Utility_bills') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportUtilitybills"
          :otherData="{
            mediaName: '近3个月水电缴纳凭证',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportUtilitybills',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Material_Input_Invoices') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportInputinvoices"
          :otherData="{
            mediaName: '近6个月原料进项发票',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportInputinvoices',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Output_Invoices') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportOutputinvoices"
          :otherData="{
            mediaName: '近6个月销项发票',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportOutputinvoices',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Material_Warehouse_Records') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportMaterialrecords"
          :otherData="{
            mediaName: '原料仓库进出货记录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportMaterialrecords',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Product_Warehouse_Records') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportProductrecords"
          :otherData="{
            mediaName: '成品仓库进出货记录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportProductrecords',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Bill_of_Material') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportBillmaterial"
          :otherData="{
            mediaName: '产品BOM物料清单',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportBillmaterial',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Production_Plan') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportProductionplan"
          :otherData="{
            mediaName: '生产计划单',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportProductionplan',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Production_Summary') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportProductionsummary"
          :otherData="{
            mediaName: '生产报表',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportProductionsummary',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Inspection_Records') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportInspectionrecords"
          :otherData="{
            mediaName: '品质检验记录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportInspectionrecords',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.The_factory_failed') }}</span>
      <div class="img">
        <show-img
          :data="closures.freportNotdocument"
          :otherData="{
            mediaName: '工厂未能提供文件资料清单',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportNotdocument',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      id: this.$route.query.id,
    };
  },
  computed: {
    factoryDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.factoryDetails),
        );
      },
    },
    closures: {
      get() {
        console.log(this.$store.state.report.factoryImgList.closures);
        return JSON.parse(
          JSON.stringify(this.$store.state.report.factoryImgList.closures),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {},
  methods: {
    //保存图片
    saveImg() {
      let fileList = [];
      let fileList1 = [];
      let fileList2 = [];
      let fileList3 = [];
      let fileList4 = [];
      let fileList5 = [];
      let fileList6 = [];
      let fileList7 = [];
      let fileList8 = [];
      let fileList9 = [];
      let fileList10 = [];
      let fileList11 = [];
      this.closures.freportTaxbill.forEach(item => {
        fileList.push(item.id);
      });
      this.closures.freportRentrecords.forEach(item => {
        fileList1.push(item.id);
      });
      this.closures.freportUtilitybills.forEach(item => {
        fileList2.push(item.id);
      });
      this.closures.freportInputinvoices.forEach(item => {
        fileList3.push(item.id);
      });
      this.closures.freportOutputinvoices.forEach(item => {
        fileList4.push(item.id);
      });
      this.closures.freportMaterialrecords.forEach(item => {
        fileList5.push(item.id);
      });
      this.closures.freportProductrecords.forEach(item => {
        fileList6.push(item.id);
      });
      this.closures.freportBillmaterial.forEach(item => {
        fileList7.push(item.id);
      });
      this.closures.freportProductionplan.forEach(item => {
        fileList8.push(item.id);
      });
      this.closures.freportProductionsummary.forEach(item => {
        fileList9.push(item.id);
      });
      this.closures.freportInspectionrecords.forEach(item => {
        fileList10.push(item.id);
      });
      this.closures.freportNotdocument.forEach(item => {
        fileList11.push(item.id);
      });
      var postData = {
        freportId: this.factoryDetails.freportId,
        freportMedianame: '企业运营',
        freportMediatype: '1',
        modelType: '7',

        freportTaxbill: fileList.join(','),
        freportRentrecords: fileList1.join(','),
        freportUtilitybills: fileList2.join(','),
        freportInputinvoices: fileList3.join(','),
        freportOutputinvoices: fileList4.join(','),
        freportMaterialrecords: fileList5.join(','),
        freportProductrecords: fileList6.join(','),
        freportBillmaterial: fileList7.join(','),
        freportProductionplan: fileList8.join(','),
        freportProductionsummary: fileList9.join(','),
        freportInspectionrecords: fileList10.join(','),
        freportNotdocument: fileList11.join(','),
      };
      // postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/factory-media/saveOrUpdateFactoryMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfactoryImg',
              this.factoryDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.Closures {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
.reportModal1 {
  .updataForm {
    display: flex;
    .ant-form-item-label {
      text-align: left;
    }
    > div {
      width: 50%;
    }
    .title {
      width: 70%;
      text-align: center;
      margin-top: 5px;
      > button {
        margin-bottom: 3px;
      }
    }
    .part {
      width: 70%;
      padding-top: 10px;
      border-bottom: 1px dashed rgba(25, 21, 37, 0.28);
      display: flex;
      .ant-form-item-label {
        flex-shrink: 0;
      }
      .ant-row {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
